import React, { useCallback, useRef, useState } from 'react'
import { Box, Button, CircularProgress, Dialog, DialogContent, IconButton, Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { Header } from 'components/Modal'

import MessageCard from './Card/Message'
import useMessages from './use-messages'

const MessageDialog = ({ open, onClose, room }) => {
  const { t } = useTranslation()
  const messageCardRef = useRef(null)
  const { messages } = useMessages()
  const [hasMessage, setHasMessage] = useState(null)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const hasSavedMessage = Boolean(messages[0]?.content?.trim())

  const handleClose = () => {
    setHasMessage(null)
    onClose()
  }

  const handleMessageChange = useCallback(newMessage => {
    setHasMessage(newMessage.trim().length > 0)
  }, [])

  const handleSaveMessage = async () => {
    if (!messageCardRef.current?.hasMessage()) {
      return
    }

    setIsSubmitting(true)
    try {
      await messageCardRef.current.handleSave()
      handleClose()
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: '24px',
          maxWidth: '480px'
        }
      }}>
      <Stack mt={2}>
        <Header icon={<i className="fa-solid fa-tv" />} title={t('stream-cast.card.edit_message_title')} />
        <IconButton
          onClick={handleClose}
          size="small"
          sx={{ position: 'absolute', right: 24 }}>
          <i className="fa-light fa-xmark" />
        </IconButton>
      </Stack>
      <DialogContent sx={{ px: 3 }}>
        {open && (
          <MessageCard
            key={room?.id || 'message-dialog'}
            ref={messageCardRef}
            isModal={true}
            room={room}
            onMessageChange={handleMessageChange}
          />
        )}
      </DialogContent>

      <Box px={3} pb={3}>
        <Stack
          direction="row"
          justifyContent="space-between"
          sx={{ mb: 3, px: 3 }}>
          <Button
            onClick={handleClose}
            variant="outlined"
            disabled={isSubmitting}
            size="small">
            {t('stream-cast.actions.cancel')}
          </Button>
          <Button
            onClick={handleSaveMessage}
            variant="contained"
            disabled={isSubmitting || !(hasMessage ?? hasSavedMessage)}
            startIcon={isSubmitting ? <CircularProgress size={20} color="inherit" /> : null}
            size="small">
            {t('stream-cast.actions.submit')}
          </Button>
        </Stack>
        <Typography
          sx={{
            fontSize: 12,
            px: 3,
            '& span': {
              color: 'error.main',
              fontWeight: 500
            },
            '& p': {
              color: 'text.secondary',
              display: 'inline'
            }
          }}>
          <span>Attention</span>
          <p> : le texte d'accueil sera diffusé sur l'intégralité des équipements du site.</p>
        </Typography>
      </Box>
    </Dialog>
  )
}

export default MessageDialog
